import '@reach/listbox/styles.css';
import './listbox.less';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import map from 'lodash/map';

import {
  ListboxInput,
  ListboxButton,
  ListboxList,
  ListboxPopover,
  ListboxOption
} from '@reach/listbox';

const PLACEHOLDER_VALUE = '@@zf-listbox-placeholder';

const ZfListbox = ({
  label,
  labelId,
  options,
  placeholder,
  selectedValue,
  className,
  onChange
})=> (
<div className={classNames('zf-listbox', className)}>
  <span id={labelId} className="zf-listbox-label">
    { label }
  </span>

  <ListboxInput
    value={selectedValue}
    aria-labelledby={labelId}
    onChange={(value)=> {
      if (value === PLACEHOLDER_VALUE) {
        return;
      }

      onChange(value);
    }}
  >
    <ListboxButton arrow="▼" />
    <ListboxPopover portal={false}>
      <ListboxList>
        <ListboxOption
          className="placeholder-option"
          value={PLACEHOLDER_VALUE}
          label={placeholder}
        />

        {
          map(options, ({ value, label, content })=> (
            <ListboxOption key={value} value={value} label={label}>
              { content }
            </ListboxOption>
          ))
        }
      </ListboxList>
    </ListboxPopover>
  </ListboxInput>
</div>
);

ZfListbox.propTypes = {
  labelId: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired
    })
  ).isRequired,
  selectedValue: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

ZfListbox.defaultProps = {
};

export default ZfListbox;
